export default __webpack_public_path__ + "static/media/3d_gismo_black.d1700514.svg";